aptis.WindowVisibilityHandler = new Class({

	/**
	 * @var {Function} handler
	 */
	registerIfVisible: function (handler) {
		this._registerChangeHandler(handler, 'visible');
	},

	/**
	 * @var {Function} handler
	 */
	registerIfHidden: function (handler) {
		this._registerChangeHandler(handler, 'hidden');
	},

	/**
	 * @param {Function} handler
	 * @param {String} raiseIfHasState
	 * @private
	 */
	_registerChangeHandler: function(handler, raiseIfHasState) {
		let visibilityState = 'visibilityState';
		let visibilityChange = 'visibilitychange';
		if (typeof document.mozHidden !== 'undefined') {
			visibilityChange = 'mozvisibilitychange';
			visibilityState = 'mozVisibilityState';
		} else if (typeof document.msHidden !== 'undefined') {
			visibilityChange = 'msvisibilitychange';
			visibilityState = 'msVisibilityState';
		} else if (typeof document.webkitHidden !== 'undefined') {
			visibilityChange = 'webkitvisibilitychange';
			visibilityState = 'webkitVisibilityState';
		}

		document.addEventListener(visibilityChange, function () {
			if (document[visibilityState] === raiseIfHasState) {
				handler();
			}
		}, false);
	},
});
